import { ChatNavBadge } from './ChatNavBadge.js';
import { Volume2, VolumeX } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { useAppStore } from '../store.js';
import { playGameSound } from '../audio.js';
import { playGameHaptic } from '../haptics.js';
import { primaryNavigationItems } from './primary-navigation.js';
import { DuelNavBadge } from './DuelNavBadge.js';

export function DesktopHeader() {
  const sound = useAppStore((state) => state.sound);
  const music = useAppStore((state) => state.music);
  const toggleAudio = useAppStore((state) => state.toggleAudio);
  const adapter = useAppStore((state) => state.adapter);
  const haptics = useAppStore((state) => state.haptics);
  const audioEnabled = sound || music;
  return (
    <header className="desktop-header">
      <div className="desktop-header-inner">
        <NavLink className="brand desktop-brand" to="/" aria-label="БлокБитва — на главную">
          <span className="brand-mark">
            <i />
            <i />
            <i />
            <i />
          </span>
          <span>
            Блок<span>Битва</span>
          </span>
        </NavLink>
        <nav aria-label="Основное меню">
          {primaryNavigationItems.map(({ to, label, icon: Icon, tone }) => (
            <NavLink
              aria-label={tone === 'chat' ? label : undefined}
              key={to}
              to={to}
              end={to === '/'}
              className={({ isActive }) => `nav-item nav-item-${tone}${isActive ? ' active' : ''}`}
              onClick={() => {
                playGameSound('navigate');
                playGameHaptic(adapter, haptics, 'navigate');
              }}
            >
              <span className="nav-icon-wrap">
                <Icon size={18} />
                {tone === 'duels' ? <DuelNavBadge /> : null}
                {tone === 'chat' ? <ChatNavBadge /> : null}
              </span>
              <span className="nav-label">{label}</span>
            </NavLink>
          ))}
          <button
            type="button"
            className="desktop-sound-toggle"
            aria-label={audioEnabled ? 'Выключить музыку и звуки' : 'Включить музыку и звуки'}
            aria-pressed={!audioEnabled}
            onClick={toggleAudio}
          >
            {audioEnabled ? <Volume2 size={19} /> : <VolumeX size={19} />}
          </button>
        </nav>
      </div>
    </header>
  );
}
